/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Hide announcement bar when Kaching cart drawer is open
  function initKachingCartObserver() {
    var announcement = document.querySelector('.header-sections .page-announcement');
    if (!announcement) return;

    var hidden = false;

    function isKachingOpen() {
      // Body class patterns
      if (/kaching.*(open|active|show|visible)/i.test(document.body.className)) return true;

      // Kaching cart element with aria-hidden="false"
      if (document.querySelector('[id*="kaching"][aria-hidden="false"]')) return true;
      if (document.querySelector('[class*="kachingbundles"][aria-hidden="false"]')) return true;

      // Kaching cart element with open/active class
      if (document.querySelector('[id*="kaching"].open, [id*="kaching"].is-open, [id*="kaching"].active')) return true;
      if (document.querySelector('[class*="kachingbundles"].open, [class*="kachingbundles"].is-open')) return true;

      // Kaching overlay visible
      var overlay = document.querySelector('[class*="kaching"][class*="overlay"], [class*="kaching"][class*="backdrop"]');
      if (overlay) {
        var s = window.getComputedStyle(overlay);
        if (s.display !== 'none' && s.visibility !== 'hidden') return true;
      }

      return false;
    }

    function update() {
      var open = isKachingOpen();
      if (open && !hidden) {
        announcement.style.setProperty('display', 'none', 'important');
        hidden = true;
      } else if (!open && hidden) {
        announcement.style.removeProperty('display');
        hidden = false;
      }
    }

    var observer = new MutationObserver(update);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'style', 'data-open']
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKachingCartObserver);
  } else {
    initKachingCartObserver();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
